export const ru_navigationdata = {
  items: [
    {
      id: 1,
      name: "Домой",
      path: "/",
    },
    {
      id: 2,
      name: "Каталог",
      path: "/catalog",
    },
    {
      id: 3,
      name: "Про компанию",
      path: "/about",
    },
    {
      id: 4,
      name: "Вакансии",
      path: "/job",
    },
    {
      id: 5,
      name: "Контакты",
      path: "/contacts",
    },
  ],
};
